import FormError from "../../../../../../packages/design-system/src/FormError";
import * as React from 'react';
export default {
  FormError,
  React
};